export default [
	{
		// 1. DEM处理
		name: 'process',
		base: {
			url: '/Dem/process',
			method: 'post',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},
	{
		// 2. 查询任务状态
		name: 'getTaskState',
		base: {
			url: '/Dem/task/',
			method: 'get',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},
	{
		// 3. 查询任务进度
		name: 'getTaskIdProcess',
		base: {
			url: '/Dem/task/',
			method: 'get',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},
	{
		// 4. 下载文件
		name: 'download',
		base: {
			// /task/{taskId}/download/{fileName}`
			// /download/
			url: '/Dem/task/',
			method: 'get',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},
	{
		// 5. 下载任务ZIP包
		name: 'downloadZip',
		base: {
			// /task/{taskId}/download-zip
			url: '/Dem/task/',
			method: 'get',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},
	{
		// 6. 获取文件库信息
		name: 'getLibraryInfo',
		base: {
			url: '/Dem/library/info',
			method: 'post',
			headers: {
			},

			// 默认数据
			data: {
			},

		},
		config: {
		}
	},

]